'use client'

// lib files
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { DONATE_FALLBACK_URL } from '@/lib/constants';
import { formatAmount } from '@/lib/helpers/format-amount';
import { getPassportLearnMoreUrl } from '@/lib/helpers/get-passport-learn-more-url';
import { StationData } from "@/lib/types/api/stations-data";
import { useIdentity } from '@/lib/hooks/useIdentity';

// components
import DonateLinkButton from '@/components/Button/DonateLinkButton';
import LinkButton from '@/components/Button/LinkButton';
import PassportLockup from '@/components/PassportLearnMore/PassportLockup/PassportLockup';
import WallofShowPostersBackgroundImage from '@/components/WallofShowPostersBackgroundImage/WallofShowPostersBackgroundImage'

// svgs
import HeartIcon from '@/public/svg/donate-heart.svg';

// styles
import styles from '@/components/Search/PassportSearchRow/PassportSearchRow.module.scss'

export interface PassportSearchRowProps {
  stationData?: StationData;
}

function PassportSearchRow(props: PassportSearchRowProps) {
  const { stationData } = props;


  const { cachedIdentity } = useIdentity();
  const isPassportMember = cachedIdentity?.isPassport || false;

  if (!stationData) {
    return null;
  }

  const { attributes } = stationData;
  const {
    annual_passport_qualifying_amount,
    passport_enabled,
    passport_url,
    short_common_name,
  } = attributes;

  const donateUrl = passport_url ? passport_url : DONATE_FALLBACK_URL;
  const passportLearnMoreUrl = getPassportLearnMoreUrl(stationData);

  if (passport_enabled === false || annual_passport_qualifying_amount === null) {
    return null;
  }

  const annualAmount = formatAmount(annual_passport_qualifying_amount);
  const monthlyAmount = formatAmount(annual_passport_qualifying_amount / 12);

  return (
    <div className={styles.passport_search_row} data-sentry-component="PassportSearchRow" data-sentry-source-file="PassportSearchRow.tsx">
      <WallofShowPostersBackgroundImage usage="rowBackground"  data-sentry-element="WallofShowPostersBackgroundImage" data-sentry-source-file="PassportSearchRow.tsx" />

      <div className={styles.passport_search_row__content}>
        <PassportLockup
          element='h2'
          shortCommonName={short_common_name}
          className={styles.passport_search_row_lockup}
        data-sentry-element="PassportLockup" data-sentry-source-file="PassportSearchRow.tsx" />
      { isPassportMember ? (
        <>
          <p className={styles.passport_search_row__thank_you}>Thank you for being a member! You are supporting America&rsquo;s largest classroom, the nation&rsquo;s largest stage for the arts and a trusted window into the world.</p>
          <p className={styles.passport_search_row__thank_you}>Questions about Passport? <a href={passportLearnMoreUrl}>Learn More</a></p>
          <div className={styles.passport_search_row__member_button_row}>
            <LinkButton
              href='/explore/passport'
              style='light_blue'
            >
              Explore Passport Shows
            </LinkButton>
            <DonateLinkButton
              href={donateUrl}
              style={'white_ghost'}
              iconBefore='heart'
              className={styles.passport_row_donate_button}
              gtmEventData={{
                feature_category: "passport search row",
                feature_name: "passport search row donate link",
                object_text: "Get Passport",
                object_url: donateUrl,
              }}
            >
              Make Another Donation
            </DonateLinkButton>
          </div>
        </>
      ) : (
        <>
          <p className={styles.passport_search_row__intro}>Donate ${monthlyAmount} per month or ${annualAmount} per year <strong>AND</strong>:</p>
          <ul className={styles.passport_search_row__donation_list}>
            <li>Get extended access to past seasons <span>of PBS shows</span></li>
            <li>Stream early releases of new series</li>
            <li>Binge watch your favorite PBS shows</li>
          </ul>
          <p className={styles.passport_search_row__heart_donation}>
            <HeartIcon /> Your donation goes to your local station!
          </p>
          <div className={styles.passport_search_row__button_row}>
            <DonateLinkButton
              href={donateUrl}
              style={'light_blue'}
              className={styles.passport_row_donate_button}
              gtmEventData={{
                feature_category: "passport search row",
                feature_name: "passport search row donate link",
                object_text: "Get Passport",
                object_url: donateUrl,
              }}
            >
              Get Passport
            </DonateLinkButton>
            <LinkButton
              href={passportLearnMoreUrl}
              style='white_ghost'
            >
              What is Passport?
            </LinkButton>

          </div>
        </>)}
      </div>
    </div>
  );
}

export default PassportSearchRow
